import { useMutation, UseMutationOptions } from 'react-query';
import { mutateSuspendMatch } from './suspendMatch';
import { TSuspendMatchBody } from './suspendMatch.types';

export const useMutationSuspendMatch = (
  options?: UseMutationOptions<unknown, unknown, TSuspendMatchBody>
) => useMutation((data) => mutateSuspendMatch(data), options);
